import { AssignPayees } from './AssignPayees';
export default AssignPayees;